<template>
  <!-- 报名成功 -->
  <div class="title">
    <div class="sign_s">
      <div class="sign_one">
        <img src="../../assets/images/baomingok.png" alt />
        <p>报名成功!</p>
        <p style="color:#2b68da;font-size:12px;">
          <template v-if="timeTishi.modify_hour != 0">
            已报名用户{{timeTishi.modify_hour}}小时内可以修改参会人信息
        </template>
        <template v-if="timeTishi.modify_hour != 0 && timeTishi.modify_time != 0">
        ，
        </template>
        <template v-if="timeTishi.modify_time != 0">
修改截止日期为{{timeTishi.modify_time,'Y-M-D h:m'|formatDates}}
        </template>
      </p>
      </div>
      <van-row class="sign_two">
        <router-link class="more-link" :to="{ name: 'OrderDetails', params: { order_no: order_no }}">
          <van-col :span="fpStatus ?8:12" class="order" style="color:#fd882b">查看订单</van-col>
        </router-link>
        <router-link to="/myInvoice" v-if="fpStatus">
          <van-col span="8" class="fapiao" style="color:#fd882b">开发票</van-col>
        </router-link>
        <router-link to="/">
          <van-col   :span="fpStatus ?8:12" style="color:#fd882b">去首页</van-col>
        </router-link>
      </van-row>
    </div>
    <div class="sign_su">
      <p>以下参会人员待完善</p>
    </div>
    <!-- 待完善人员列表 -->
    <div class="sign_suc">
    <div class="hy_order">
            <div class="div">
              <div class="order_list" v-if="showText">
                <template v-for="(items,index) in allList">
                  <van-row class="order_items" v-if="items.use_status == 2">
                      <van-col span="24">
                        <van-row>
                          <van-col span="12">
                            <div class="imgbox">
                              <img src="../../../src/assets/images/index/huiyi-img2.jpg" alt />
                            </div>
                            <p>{{items.name =='' ? '未填写':items.name}}</p>
                          </van-col>
                          <van-col span="12" class="r" style="text-align: right;">
                            <span class="span" style="color:black">{{items.tel == '' ? '未填写':items.tel}}</span>
                          </van-col>
                        </van-row>
                      </van-col>
                      <van-col span="24" style="padding-top:10px">
                        <van-row>
                          <van-col span="14" class="tick">
                            <p>{{items.ticket_name}}</p>
                          </van-col>
                          <van-col span="8" class="r2">
                            <span class="span" style="color:#2b68da" @click="goPath(index)">去填写 ></span>
                          </van-col>
                        </van-row>
                      </van-col>
                    </van-row>
                </template>
              </div>
              <div  class="order_list" v-else style="text-align: center;padding:30px 0px;">
                无待完善人员
              </div>
            </div>
          </div>
    </div>
    <template v-if="allList.length >0">
      <footerFixed :id="allList[0].conference_id"/>
    </template>


  <van-notify v-model="xxtishi" type="success" duration='notify' background='#f4f8ff' color='#2b68da'>
    <van-icon name="warning-o" style="margin-right: 6px;font-size: 20px;" />
      <span style="font-size:12px;">您选择了“线下支付”，请联系会议工作人员进行现场支付</span>
    </van-notify>
  </div>
</template>

<script>
  import { formatDates ,formatWeekDate } from "../../assets/js/date";
  import footerFixed from  '@/components/common/fixed_setting'
  export default {
    components: {
      footerFixed
    },
  data() {
    return {
      order_no:'',
      page: 1,
      pagesize: 2,
      total: 0 ,//总条数
      allList: [],
      data:[],
      showText: false,
      footerNav: false,
      xxtishi:false,
      timeTishi:{
        modify_hour:0,
        modify_time:0
      },
      fpStatus:false,
    };
  },
  /* 时间过滤 */
  filters: {
    formatDates,//调用方法formatTime(1575346406, 'Y年M月D日 h:m:s')
    formatWeekDate //
  },
  created: function(){
    var _this = this;
    _this.order_no = _this.$route.params.order_no;
    _this.onLoad();
    _this.$WXConfig.wxShowMenu({ifshare:true,that:_this,data:''});
    var xianxia =  sessionStorage.getItem('hy_xianxia_'+_this.order_no);
    if(xianxia === 'offline'){
      _this.xxtishi = true;
      sessionStorage.removeItem('hy_xianxia_'+_this.order_no)
    }
  },
  methods: {
     //打开底部链接
    openFooterNav(val) {
        //   this.$toast(val);
        if (this.footerNav) {
          this.footerNav = false;
        } else {
          this.footerNav = true;
        }
    },
    goPath(i) {
      var _this = this;
      var _thisbox = {c_id:_this.allList[i].conference_id,t_id:_this.allList[i].ticket_id,order_no:_this.order_no,has_id:''};
      sessionStorage.setItem('order_isok_'+_thisbox.t_id,JSON.stringify(_thisbox));
      this.$router.push('/orderperfect/'+_thisbox.t_id);
    },
    //待完善人员列表
    onLoad() {
        var _this = this;
        _this.page++;
        let url = "/ac1/conference/fillInEnrollList";
        let params = {
          order_no:_this.order_no
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            _this.allList = res.posts;
            for(var i=0;i<_this.allList.length;i++){
              sessionStorage.removeItem('huiyi_orderlist'+_this.allList[0].conference_id);
              _this.allList[i].order_no = _this.order_no;
              if( _this.allList[i].use_status == 2){
                _this.showText = true;
              }
            }
            _this.getFapiaoStatus();
          }
        });
      let url2 = "/ac1/conference/orderModifyTime";
      let params2 = {
        order_no:_this.order_no
      };
      _this.$get(url2, params2).then(res => {
        if (res.code == "1") {
          _this.timeTishi = res.posts;
        }
      });
    },
    getFapiaoStatus(){
      var _this = this;
      let url = "/ac1/conference/isinvoice";
      let params = {
        id:_this.allList[0].conference_id
      };
      _this.$get(url, params).then(res => {
        if (res.code == "1") {
          _this.fpStatus = res.posts.is_invoice;
        }
      });
    },
  }
};
</script>

<style lang="less" scoped>
.title {
  width: 100%;
  min-height: 100vh;
  background: #f7f7f7;
  font-size: 28px;
  .sign_s {
    font-size: 30px;
    background-color: white;
    padding: 100px 30px;
    letter-spacing: 3px;
    .sign_one {
      text-align: center;
      font-weight: 600;
      img {
        display: inline-block;
        width: 103px;
        height: 103px;
        margin-bottom: 28px;
      }
      p {
        margin-bottom: 30px;
      }
      .tishi{
        min-height: 20px;
        margin-bottom: 30px;
        padding: 5px 20px;
      }
    }
    .sign_two {
      width: 523px;
      height: 88px;
      line-height: 88px;
      padding: 0 20px;
      text-align: center;
      border: 1px solid #fd882b;
      color: #fd882b;
      margin: auto;
      border-radius: 100px;
      text-align: center;
      .order,.fapiao {
        position: relative;
      }
      .order::after {
        content: "";
        height: 60px;
        width: 2px;
        position: absolute;
        right: 0;
        top: 14px;
        background: linear-gradient(to top, #f2f2f2, #fd882b, #eaeaea);
      }
      .fapiao::after {
        content: "";
        height: 60px;
        width: 2px;
        position: absolute;
        right: 0;
        top: 14px;
        background: linear-gradient(to top, #f2f2f2, #fd882b, #eaeaea);
      }
    }
  }
  .sign_su {
    width: 100%;
    height: 80px;
    background-color: #f4f8ff;
    line-height: 80px;
    font-size: 26px;
    color: #2b68da;
    padding: 0px 30px;
  }
  .sign_suc {
    width: 100%;
    .hy_order {
      width: 100%;
      .div {
        .order_title{
          margin: 0px 30px;
          font-size:30px;
          font-weight: 600;
          padding-left: 10px;
          line-height: 30px;
          border-left: 6px solid #189bff;
        }
        >p {
          color: black;
          font-size: 30px;
          line-height: 40px;
          font-weight: 400;
          padding: 40px 30px;
          border-bottom: 2px solid #ebebeb;
        }
        >span {
          display: inline-block;
        }
        .order_list{
          width:100%;
          padding:0px 30px;
          border-bottom: 2px solid #ebebeb;
          .px_title{
            line-height: 35px;
            font-size: 28px;
            color: #333;
            padding-top: 20px;
          }
          >.van-row {
            font-size: 28px;
            line-height: 80px;
            overflow: hidden;
            letter-spacing: 3px;
            text-align: left;
            padding: 20px 0px;
            border-bottom: 2px dashed #ebebeb;
            .van-col {
              overflow: hidden; /*超出部分隐藏*/
              white-space: nowrap; /*不换行*/
              text-overflow: ellipsis; /*超出部分文字以...显示*/
              .imgbox{
                display: block;
                width: 70px;
                height: 70px;
                position: relative;
                vertical-align: middle;
                float: left;
                margin-right: 20px;
                overflow: hidden;
                img {
                  width: 100%;
                  height: 100%;
                  display: block;
                  border-radius: 50%;
                }
              }
              >p{
                font-size: 28px;
                color: #333;
                float: left;
                width: 250px;
                line-height: 70px;
                overflow: hidden; /*超出部分隐藏*/
                white-space: nowrap; /*不换行*/
                text-overflow: ellipsis; /*超出部分文字以...显示*/
              }
              .r{
                height: 70px;
                .span {
                  color: #f95d34;
                  font-size: 24px;
                  display: block;
                  line-height: 70px;
                  width: 100%;
                }
              }
              .tick {
                color: #f95d34;
                p {
                  width: 100%;
                  //padding: 0px 10px 0px 20px;
                  //  background-color: #ffe4dd;
                  margin: 0;
                  overflow: hidden; /*超出部分隐藏*/
                  white-space: nowrap; /*不换行*/
                  text-overflow: ellipsis; /*超出部分文字以...显示*/
                  line-height: 55px;
                  font-size: 26px;
                  font-weight: normal;
                  border-radius: 10px;
                  color: #f95d34;
                }
              }
              .r2{
                height: 55px;
                float: right;
                .span{
                  line-height: 55px;
                  font-size: 24px;
                  display: block;
                  width: 100%;
                  text-align: right;
                  color: #999;
                  &.active{
                    color:#2b68da
                  }
                }
              }
            }
            &:last-child{
              border-bottom: none;
            }
          }
          &:last-child{
            border-bottom: none;
          }
        }
      }
    }
  }
}
</style>
